const styles = () => ({
  '& > div': {
    height: '100%',
  },
  flex: 1,
  minHeight: 100,
});

export default styles;
